<template>
    <div class="vx-card p-6">
        <div class="vx-row">
            <div class="vx-col lg:w-1/2 md:w-1/2 sm:w-full w-full">
                <h3>Thông tin gói dịch vụ</h3>
            </div>
        </div>
        <div class="vx-row">
            <div class="vx-col lg:w-1/3 md:w-1/2 sm:w-full w-full mt-4">
                <label class="vs-input--label required">Chi nhánh</label>
                <v-select class="w-full" v-model="selectedBranch" :options="branchOptions" :clearable="false"
                          v-validate="'required'" name="branch" :disabled="isUpdate">
                    <span slot="no-options"> {{ $t('menuOrganization.noOption') }}</span>
                </v-select>
                <span class="text-danger text-sm">{{ errors.first('branch') }}</span>
            </div>
            <div class="vx-col lg:w-1/3 md:w-1/2 sm:w-full w-full mt-4">
                <label class="vs-input--label required">Mã gói dịch vụ</label>
                <vs-input class="w-full" v-model="comboServiceInfo.code" name="codeCombo"
                          v-validate="'required'"></vs-input>
                <span class="text-danger text-sm">{{ errors.first('codeCombo') }}</span>
            </div>
            <div class="vx-col lg:w-1/3 md:w-1/2 sm:w-full w-full mt-4">
                <label class="vs-input--label required">Tên gói dịch vụ</label>
                <vs-input class="w-full" v-model="comboServiceInfo.name" name="nameCombo"
                          v-validate="'required'"></vs-input>
                <span class="text-danger text-sm">{{ errors.first('nameCombo') }}</span>
            </div>
            <div class="vx-col lg:w-1/3 md:w-1/2 sm:w-full w-full mt-4">
                <label class="vs-input--label required">Giá tiền</label>
                <vs-input class="w-full" v-model="comboServiceInfo.price" name="unitPrice" v-validate="'required'"
                          @input="convert($event)"></vs-input>
                <span class="text-danger text-sm">{{ errors.first('unitPrice') }}</span>
            </div>
            <div class="vx-col lg:w-1/3 md:w-1/2 sm:w-full w-full mt-4">
                <label class="vs-input--label">Điểm thưởng</label>
                <vs-input class="w-full" v-model="comboServiceInfo.point" name="pointCombo" v-validate="''"></vs-input>
                <span class="text-danger text-sm">{{ errors.first('pointCombo') }}</span>
            </div>
            <div class="vx-col lg:w-1/3 md:w-full sm:w-full w-full mt-4">
                <label class="vs-input--label">Ghi chú</label>
                <vs-textarea class="w-full" v-model="comboServiceInfo.description" name="description"/>
            </div>
        </div>
        <vs-divider></vs-divider>
        <div class="vx-row">
            <div class="vx-col lg:w-1/3 md:w-1/2 sm:w-full mt-4">
                <label class="vs-input--label">Ảnh mô tả dịch vụ</label>
                <vue-upload-multiple-image class="m-auto" @upload-success="uploadImageSuccess"
                                           @before-remove="beforeRemove"
                                           @edit-image="editImage" @data-change="dataChange" :data-images="images">
                </vue-upload-multiple-image>
            </div>
            <div class="vx-col lg:w-2/3 md:w-full sm:w-full mt-4" v-if="comboServiceInfo.organizationBranchId">
                <v-tree ref='tree' @node-select="saveNodeSelected" @node-check="saveNodeSelected" :data='treeData'
                        :multiple="true" :halfcheck='true' :tpl='tpl'/>
            </div>
        </div>

        <div class="vx-row">
            <div class="vx-col w-full">
                <div class="md:float-right md:mt-0 sm:mt-4 mt-4 flex">
                    <vs-button class="mr-2" color="primary" @click="saveData"
                               v-if="(isUpdate && isPermissionUpdateServiceCombo) || (!isUpdate && isPermissionCreateServiceCombo)">
                        {{ `${isUpdate ? 'Cập nhật' : 'Tạo mới'}` }}
                    </vs-button>
                    <vs-button class="" color="warning" type="border" @click="$router.push('/user/manage-service-combo')">Quay lại</vs-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import vSelect from 'vue-select';
import Vue from 'vue';
import {VTree} from 'vue-tree-halower';
import VueUploadMultipleImage from '../../../../components/VueUploadMultipleImage';
import authConfig from '@/../auth_config.json';
import {isAPI, isRouter} from "../../../../store/permission";
import {constAPI, constRouter} from "../../../../store/constant";

Vue.use(VTree);

export default {
    data() {
        return {
            comboServiceInfo: {
                code: null,
                name: null,
                description: null,
                organizationBranchId: null,
                price: null,
            },
            branchOptions: [],
            isUpdate: false,
            treeData: [{
                title: "Danh sách dịch vụ",
                expanded: true,
                children: []
            }],
            listPermisionCheck: [],
            beautyComboService: [],
            images: [],
        }
    },

    components: {
        vSelect,
        VueUploadMultipleImage,
    },

    computed: {

        selectedBranch: {
            get() {
                let obj = this.branchOptions.find(x => x.value === this.comboServiceInfo.organizationBranchId);
                if (!obj) return;
                return {
                    value: obj.value,
                    label: obj.label
                }
            },
            set(obj) {
                this.comboServiceInfo.organizationBranchId = obj ? obj.value : null;
                this.getServicePacks();
            }
        },

        validateForm() {
            return !this.errors.any()
        },
    },

    async created() {

        let branchList = JSON.parse(localStorage.getItem('branchInfoList') || '[]');
        this.branchOptions = branchList.map(x => {
            return {label: x.organizationBranchName, value: x.id}
        });
        if (this.$route.query.id) {
            this.isUpdate = true;
            let id = parseInt(this.$route.query.id);
            await this.findById(id);
            for (const x of this.comboServiceInfo.fileManagers) {
                let data = await this.toDataURL(x.url);
                let dataImage = data.xhr.response;
                let metadata = {
                    type: 'image/jpeg'
                };
                let file = new File([dataImage], x.fileName, metadata);
                this.images.push({
                    name: x.fileName,
                    path: data.imgBase64,
                    highlight: 1,
                    default: 1,
                    file: file
                });
            }
        }
    },

    methods: {

        onInputChange(node, event) {
            node.inputVal = event.target.value
        },

        getServicePacks() {
            // this.$vs.loading()
            this.$crm.post('/beauty-service-package-department/find-by-condition', {organizationBranchId: this.comboServiceInfo.organizationBranchId}).then(res => {
                let listGroup = res.data.content;
                listGroup = [...new Set(listGroup)];
                let treeDataTmp = [];

                listGroup.forEach(q => {
                    let checked = this.beautyServicePackageInfo ? this.beautyServicePackageInfo.some(per => per.beautyServicePackage.id == q.beautyServicePackage.id) : false;
                    let data = this.beautyServicePackageInfo ? this.beautyServicePackageInfo.find(per => per.beautyServicePackage.id == q.beautyServicePackage.id) : null
                    let listChildren = {
                        title: q.beautyServicePackage.code + '-' + q.beautyServicePackage.name,
                        id: q.beautyServicePackage.id,
                        beautyServiceId: q.beautyServicePackage.beautyServiceId,
                        checked,
                        times: data ? data.times : null,
                    }

                    let checkData = treeDataTmp.find(x => x.id == q.beautyService.id) ? true : false;
                    if (!checkData) {
                        treeDataTmp.push({
                            title: q.beautyService.code + '-' + q.beautyService.name,
                            id: q.beautyService.id,
                            expanded: true,
                            children: [listChildren],
                            description: q.beautyService.description
                        })
                    } else {
                        let result = treeDataTmp.find(x => x.id == q.beautyService.id);
                        result.children.push(listChildren);
                        treeDataTmp = treeDataTmp.filter(x => x.id !== q.beautyService.id);
                        treeDataTmp.push(result);
                    }
                });

                this.treeData = [{
                    title: "Danh sách dịch vụ",
                    expanded: true,
                    children: [...treeDataTmp]
                }];
                this.$vs.loading.close();
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },

        saveNodeSelected() {
            let listNodesSelected = []
            if (this.$refs.tree) {
                listNodesSelected = this.$refs.tree.getCheckedNodes().filter(x => x.beautyServiceId);
            }

            this.listPermisionCheck = []
            listNodesSelected.forEach(per => {
                let inputValue = document.getElementById(per.id).value;
                this.treeData[0].children.map(el => {
                    el.children.map(x => {
                        if (x.id === per.id) {
                            x.times = parseInt(inputValue) ? parseInt(inputValue) : null;
                            per.times = parseInt(inputValue) ? parseInt(inputValue) : null;
                        }
                        return x;
                    })
                })

                if (per.id) {
                    let dataPush = {
                        beautyServicePackageId: per.id,
                        times: per.times
                    }
                    this.listPermisionCheck.push(dataPush);
                }
            })
        },

        async saveData(evt) {
            this.comboServiceInfo.beautyPackageComboDetails = this.listPermisionCheck;
            delete this.comboServiceInfo.beautyServicePackages;
            this.comboServiceInfo.price = this.comboServiceInfo.price.replaceAll(',', '');

            evt.preventDefault();
            if (!this.validateForm) return;
            const result = await this.$validator.validateAll();
            if (!result) return;

            if (this.listPermisionCheck.length == 0) {
                return this.$vs.notify({
                    text: 'Dịch vụ là trường bắt buộc!',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                })
            }

            const blob = new Blob([JSON.stringify(this.comboServiceInfo)], {type: 'application/json'});
            const formData = new FormData();
            this.images.forEach(x => formData.append('files', x.file));
            formData.append('dto ', blob);

            let url = this.isUpdate ? '/beauty-package-combo/update' : '/beauty-package-combo/create';

            // this.$vs.loading();
            this.$crm.post(url, formData).then(() => {
                this.$vs.notify({
                    text: `${this.isUpdate ? 'Cập nhật' : 'Tạo mới'} ' gói dịch vụ thành công!'`,
                    iconPack: 'feather',
                    icon: 'icon-check-circle',
                    color: 'success'
                });
                this.$router.push('/user/manage-service-combo');
                this.$vs.loading.close();
            }).catch((err) => {
                this.comboServiceInfo.price = this.numberWithCommas(this.comboServiceInfo.price);
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },

        findById(id) {
            return new Promise((resolve, reject) => {
                // this.$vs.loading();
                this.$crm.get(`/beauty-package-combo/find-by-id/${id}`).then(res => {
                    this.comboServiceInfo = res.data;
                    this.comboServiceInfo.price = this.numberWithCommas(res.data.price);
                    this.beautyServicePackageInfo = res.data.beautyPackageComboDetails;
                    this.listPermisionCheck = this.beautyServicePackageInfo.map(el => {
                        return {
                            id: el.id,
                            beautyServicePackageId: el.beautyServicePackage.id,
                            times: el.times
                        }
                    });
                    this.getServicePacks();
                    resolve();
                    this.$vs.loading.close();
                }).catch((err) => {
                    reject();
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            })
        },

        tpl(...args) {
            let {0: node, 2: parent, 3: index} = args
            let titleClass = node.selected ? 'node-title node-selected' : 'node-title'
            if (node.searched) titleClass += ' node-searched'

            if (node.beautyServiceId) {
                return <span>
                    <span class={titleClass} domPropsInnerHTML={node.title} onClick={() => {
                        this.$refs.tree.nodeSelected(node)
                    }}></span>
                    <input class="inputTree" value={node.times} id={node.id} onChange={() => {
                        this.$refs.tree.nodeSelected(node)
                    }}>buổi</input>
                </span>
            } else {
                return <span>
                    <span class={titleClass} domPropsInnerHTML={node.title} onClick={() => {
                        this.$refs.tree.nodeSelected(node)
                    }}></span>
                </span>
            }
        },

        numberWithCommas(x) {
            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        },

        convert(e) {
            let str = e.split(' ')
                .join('')
                .replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a")
                .replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e")
                .replace(/ì|í|ị|ỉ|ĩ/g, "i")
                .replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o")
                .replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u")
                .replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y")
                .replace(/đ/g, "d")
                .replace(/À|Á|Ạ|Ả|Ã|Â|Ầ|Ấ|Ậ|Ẩ|Ẫ|Ă|Ằ|Ắ|Ặ|Ẳ|Ẵ/g, "A")
                .replace(/È|É|Ẹ|Ẻ|Ẽ|Ê|Ề|Ế|Ệ|Ể|Ễ/g, "E")
                .replace(/Ì|Í|Ị|Ỉ|Ĩ/g, "I")
                .replace(/Ò|Ó|Ọ|Ỏ|Õ|Ô|Ồ|Ố|Ộ|Ổ|Ỗ|Ơ|Ờ|Ớ|Ợ|Ở|Ỡ/g, "O")
                .replace(/Ù|Ú|Ụ|Ủ|Ũ|Ư|Ừ|Ứ|Ự|Ử|Ữ/g, "U")
                .replace(/Ỳ|Ý|Ỵ|Ỷ|Ỹ/g, "Y")
                .replace(/Đ/g, "D")
                .replace(/\u0300|\u0301|\u0303|\u0309|\u0323/g, "")
                .replace(/\u02C6|\u0306|\u031B/g, "")
                // eslint-disable-next-line no-useless-escape
                .replace(/!|@|%|\^|\*|\(|\)|\+|\=|\<|\>|\?|\/|,|\.|\:|\;|\'|\"|\&|\#|\[|\]|~|\$|_|`|-|{|}|\||\\/g, " ")
                .trim()
                .toLowerCase();

            if (str.match(/[a-z]/i)) {
                return this.$vs.notify({
                    text: 'Đơn giá phải là ký tự số!',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            }
            this.comboServiceInfo.price = this.numberWithCommas(e.replaceAll(',', ''));
        },

        uploadImageSuccess(formData, index, fileList, file) {
            this.images = fileList;
            this.setIsUpdateImages();
        },
        beforeRemove(index, done, fileList) {
            this.images = fileList
            this.setIsUpdateImages();
            done();
        },
        editImage(formData, index, fileList) {
            this.images = fileList;
            this.setIsUpdateImages();
        },
        dataChange(data) {
            this.images = fileList;
            this.setIsUpdateImages();
        },
        setIsUpdateImages() {
            if (this.isUpdate) {
                this.isUpdateImages = true;
            }
        },

        toDataURL(url) {
            return new Promise(resolve => {
                let xhr = new XMLHttpRequest();
                xhr.onload = function () {
                    let reader = new FileReader();
                    reader.onloadend = function () {
                        resolve({imgBase64: reader.result, xhr: xhr});
                    }
                    reader.readAsDataURL(xhr.response);
                };
                xhr.open('GET', url);
                xhr.responseType = 'blob';
                xhr.send();
            })
        },

        isPermissionCreateServiceCombo() {
            return isAPI(this, constAPI.beauty_pack_create);
        },

        isPermissionUpdateServiceCombo() {
            return isAPI(this, constAPI.beauty_pack_update);
        },

    }
}
</script>

<style scoped>
.required:after {
    content: " *";
    color: red;
}
</style>
